 export const urlAzure = "https://appwebreq.mariaalmenara.net:2716/"  //azure 
      export const url = "https://appwebreq.mariaalmenara.net:2716/" //sap

    
    //export const urlAzure = "https://appwebreq.mariaalmenara.net:2716/"  //azure
    //export const url = "https://appwebreq.azurewebsites.net/" //sap
    // export const url = "https://apiwebreq.benjacovi.dev/" //sap
    // export const urlAzure = "https://apiwebreq.benjacovi.dev/"  //azure 

    //  export const urlAzure = "https://localhost:7004/"  //azure
 //export const url = "https://localhost:7004/" //sap

// // export const url = "https://localhost:7004/"